import React, { useRef } from 'react';
import Button from './ui/Button';
import Card from './ui/Card';
import SectionWrapper from './ui/SectionWrapper';
import { a2zVendor, sourcingSpotlightItems } from '../../data/a2zRentalCatalog';

export default function ProductionSourcingSection({ onViewAll }) {
  const scrollRef = useRef(null);

  const scrollBy = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = Math.min(280, el.clientWidth * 0.85);
    el.scrollBy({ left: direction * amount, behavior: 'smooth' });
  };

  return (
    <SectionWrapper className="mt-10">
      <div className="mb-1 flex items-center justify-between gap-4">
        <h2 className="text-base sm:text-lg font-bold tracking-wide text-gray-900 uppercase">
          Production sourcing
        </h2>
        <Button
          type="button"
          variant="text"
          onClick={onViewAll}
          className="shrink-0 text-xs sm:text-sm font-bold uppercase tracking-wide text-[#4B4EA2] hover:text-[#3D407F]"
        >
          View all →
        </Button>
      </div>
      <p className="mb-4 text-xs text-gray-500">
        Featured from {a2zVendor.name} ·{' '}
        {a2zVendor.address
          .split(',')
          .slice(-2)
          .map((s) => s.trim())
          .join(', ')}
      </p>

      <div className="flex items-stretch gap-2 sm:gap-3">
        <button
          type="button"
          onClick={() => scrollBy(-1)}
          className="hidden sm:flex shrink-0 w-9 h-9 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 text-lg leading-none shadow-sm hover:bg-gray-50"
          aria-label="Scroll sourcing cards left"
        >
          ‹
        </button>

        <div
          ref={scrollRef}
          className="flex min-w-0 flex-1 gap-4 overflow-x-auto pb-2 scroll-smooth [scrollbar-width:thin] [scrollbar-color:#cbd5e1_#f1f5f9]"
        >
          {sourcingSpotlightItems.map((item) => (
            <Card
              key={item.title}
              className="min-w-[200px] max-w-[220px] shrink-0 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm"
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-100 text-xl">
                {item.icon}
              </div>
              <h3 className="mt-3 text-[15px] font-semibold leading-snug text-gray-900">{item.title}</h3>
              <p className="mt-1.5 text-[11px] font-semibold tracking-wider text-gray-500 uppercase">
                {item.price}
              </p>
            </Card>
          ))}
        </div>

        <button
          type="button"
          onClick={() => scrollBy(1)}
          className="hidden sm:flex shrink-0 w-9 h-9 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 text-lg leading-none shadow-sm hover:bg-gray-50"
          aria-label="Scroll sourcing cards right"
        >
          ›
        </button>
      </div>

      <div className="mt-2 flex items-center gap-2 sm:hidden">
        <button
          type="button"
          onClick={() => scrollBy(-1)}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600"
          aria-label="Scroll left"
        >
          ‹
        </button>
        <div className="h-1.5 flex-1 rounded-full bg-gray-200" aria-hidden />
        <button
          type="button"
          onClick={() => scrollBy(1)}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600"
          aria-label="Scroll right"
        >
          ›
        </button>
      </div>
    </SectionWrapper>
  );
}
